//
import Model from "@/models/Model"

/**
 * 
 */
export default class ATake extends Model {

    /**
     * 
     */
    resource() {
        return "take"
    }
}